<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>店面费用</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button size="mini"
               v-if="authorities.includes('finance.dianmianfeiyong.new')"
               @click="toNewShopCostPage">新建店面费用</el-button>
    <el-button size="mini"
               v-if="authorities.includes('finance.dianmianfeiyong.copy')"
               @click="toCopyShopCostPage">复制店面费用</el-button>
    <el-button size="mini"
               v-if="authorities.includes('finance.dianmianfeiyong.edit')"
               @click="toEditUserSubsidyPage">编辑店面费用</el-button>
    <el-date-picker
      v-model="costRequest.selectMonth"
      type="monthrange"
      range-separator="至"
      start-placeholder="开始月份"
      end-placeholder="结束月份"
      size="mini"
      @change="getMonth"
      value-format="yyyy-MM"
    >
    </el-date-picker>
    <el-select v-model="selectOrgId" v-if="orgLevel == 2" clearable value filterable placeholder="请选择门店"
               style="margin-left: 5px;width: 200px" size="mini" @change="getShop">
      <el-option
        v-for="org in shop"
        :key="org.id"
        :label="org.orgName"
        :value="org.id">
      </el-option>
    </el-select>
    <el-select v-model="selectOrgCostId" clearable value filterable placeholder="请选择补助类目"
               style="margin-left: 5px;width: 200px" size="mini" @change="getOrgCostMethod">
      <el-option
        v-for="orgCost in orgCostList"
        :key="orgCost.costId"
        :label="orgCost.costCnName"
        :value="orgCost.costId">
      </el-option>
    </el-select>
    <el-button size="mini" style="margin-left: 5px;" @click="queryShopCosts">查询</el-button>
    <el-table height="550px" :data="userCostList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}" >
      <el-table-column
        align="center"
        fixed="fixed"
        label="操作" width="100"
      >
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-evenly">
            <el-link icon="el-icon-edit" size="mini"
                     type="primary"  @click="showUpdateCostDialog(scope.row)"
            ></el-link>
            <el-link type="primary" v-if="authorities.includes('finance.dianmianfeiyong.delete')" icon="el-icon-delete"
                   @click="deleteUserCost(scope.row)"></el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="costDate"
        width="120"
        label="时间">
      </el-table-column>
      <el-table-column
        align="center"
        prop="costCnName"
        label="费用类目">
      </el-table-column>
      <el-table-column
        align="center"
        prop="orgName"
        label="门店">
      </el-table-column>
      <el-table-column
        align="center"
        prop="money"
        label="金额">
      </el-table-column>
      <el-table-column
        align="center"
        prop="comment"
        label="备注">
      </el-table-column>
      <el-table-column
        align="center"
        prop="createName"
        label="创建人">
      </el-table-column>
      <el-table-column
        align="center"
        prop="createTime"
        label="创建时间">
      </el-table-column>
      <el-table-column
        align="center"
        prop="modifyName"
        label="最后修改人">
      </el-table-column>
      <el-table-column
        align="center"
        prop="modifyTime"
        label="最后修改时间">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[15, 30, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="currentTotal">
    </el-pagination>


    <el-dialog
      title="更新店面费用"
      :visible.sync="updateCostDialogVisible"
      width="60%"
      @close="closeUpdateCostDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-evenly; width: 100%;align-items: center">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <span style="width: 60px">选择月份:</span>
            <el-date-picker
              v-model="updateUserCost.costDate"
              type="month"
              placeholder="选择月份"
              value-format="yyyy-MM"
              size="mini"
              style="width: 70%"
            >
            </el-date-picker>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <span style="width: 60px">费用类型:</span>
            <el-input v-model="updateUserCost.costCnName" disabled style="width: 60%" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <span style="width: 60px">支出金额:</span>
            <el-input v-model="updateUserCost.money" disabled style="width: 60%" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <span style="width: 60px">所属门店:</span>
            <el-input v-model="updateUserCost.orgName" disabled style="width: 60%" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <span>备注说明：</span>
        <el-input v-model="updateUserCost.comment" style="width: 100%" size="mini" type="textarea"></el-input>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeUpdateCostDialog">取 消</el-button>
        <el-button size="mini" @click="updateUserCostMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgId:'',
      userId:'',
      userName:'',
      authorities:'',
      orgLevel:'',
      userCostDialogVisible:false,
      updateCostDialogVisible:false,
      userCostList:[],
      orgCostList:[],
      shops:[],
      selectShops:[],
      selectOrgCostId:'',
      costRequest:{
        selectMonth:'',
        pageNum:'',
        pageSize:'',
        costType:'',
        orgId:'',
        loadUsersOrgId:'',
        costDate:'',
        costId:'',
        queryText:''
      },
      userCost:{
        costDate:'',
        money:'',
        orgId:'',
        costId:'',
        creator:'',
        comment:'',
        orgList:[],
        createName:''
      },
      updateUserCost:'',
      currentPage: 1,
      pageSize: 30,
      currentTotal: 0,
      shopDialogVisible:false,
      currentPage1: 1,
      pageSize1: 30,
      currentTotal1: 0,
      selectOrgId:'',
      shop:[],
      createUserSubsidyDoubleClick:false
    }
  },
  methods:{
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadUserCosts();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadUserCosts();
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.loadShop();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.loadShop();
    },
    toNewShopCostPage(){
      this.$router.push("/new/shop/cost")
    },
    toCopyShopCostPage(){
      this.$router.push("/copy/shop/cost")
    },
    toEditUserSubsidyPage(){
      this.$router.push('/edit/shop/cost')
    },
    queryShopCosts(){
      this.loadUserCostCount();
      this.loadUserCosts();
    },
    async loadUserCostCount(){
      this.costRequest.orgId = this.orgId;
      if(this.selectOrgId !== ''){
        this.costRequest.orgId = this.selectOrgId;
      }
      if (this.costRequest.selectMonth !== ''){
        this.costRequest.startDateStr = this.costRequest.selectMonth[0];
        this.costRequest.endDateStr = this.costRequest.selectMonth[1];
      } else {
        this.costRequest.startDateStr = this.getNowMonth();
        this.costRequest.endDateStr = this.getNowMonth();
      }
      const {data:res} = await this.$http.post(`/count/cost/shopCosts`, this.costRequest);
      if (res.code === 200){
        this.currentTotal = res.totalPage;
      }
    },
    async loadUserCosts(){
      this.costRequest.pageNum = this.currentPage;
      this.costRequest.pageSize = this.pageSize;
      this.costRequest.orgId = this.orgId;
      if(this.selectOrgId !== ''){
        this.costRequest.orgId = this.selectOrgId;
      }
      if (this.costRequest.selectMonth !== ''){
        this.costRequest.startDateStr = this.costRequest.selectMonth[0];
        this.costRequest.endDateStr = this.costRequest.selectMonth[1];
      } else {
        this.costRequest.startDateStr = this.getNowMonth();
        this.costRequest.endDateStr = this.getNowMonth();
      }
      const {data:res} = await this.$http.post(`/list/cost/shopCosts`, this.costRequest);
      if (res.code === 200){
        this.userCostList = res.data;
      }
    },
    async deleteUserCost(row){
      const {data:res} = await this.$http.post(`/cost/delete/userCost`, row);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      await this.loadUserCosts();
    },
    async loadShop(){
      this.costRequest.pageSize = this.pageSize1;
      this.costRequest.pageNum = this.currentPage1;
      this.costRequest.loadUsersOrgId = this.orgId;
      this.costRequest.costDate = this.userCost.costDate;
      this.costRequest.costId = this.userCost.costId;
      const {data:res} = await this.$http.post(`/cost/shops`, this.costRequest);
      this.shops = res.data.list;
      this.currentTotal1 = res.data.total;
    },
    async loadOrgCost(){
      const {data:res} = await this.$http.get(`/cost/orgId/${this.orgId}/costType/${3}`);
      this.orgCostList = res.data;
    },
    getOrgCostMethod(data){
      this.selectOrgCostId = data;
      this.userCost.costId = data;
      this.costRequest.costId = data;
    },
    async loadShopList(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      this.shop = res.data;
    },
    async getShop(data){
      this.selectOrgId = data;
      if (data === ''){
        this.selectOrgId = '';
      }
    },
    getMonth(data){
      if (data !== null){
        this.costRequest.selectMonth = data;
      } else {
        this.costRequest.selectMonth = '';
      }
      this.loadUserCostsCount();
      this.loadUserCosts();
    },
    getNowMonth() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      month = month < 10 ? '0' + month : month
      return `${year}-${month}`
    },

    showUpdateCostDialog(data){
      this.updateUserCost = data;
      this.updateCostDialogVisible = true;
    },
    closeUpdateCostDialog(){
      this.updateCostDialogVisible = false;
    },
    async updateUserCostMethod(){
      //检查是否该月已经存在数据
      // const {data:re} = await this.$http.post(`/check/cost/user`, this.updateUserCost);
      // if (re.data > 0){
      //   await this.loadUserCosts();
      //   return this.$message.warning("该月已经存在数据，不能修改到此月！")
      // }
      this.updateUserCost.modifyName = this.userName;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.put(`/cost/user`, this.updateUserCost);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      await this.loadUserCosts();
      this.closeUpdateCostDialog();
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.userName = window.sessionStorage.getItem("userName");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.loadOrgCost();
    this.loadUserCostCount();
    this.loadUserCosts();
    if (this.orgLevel == 2){
      this.loadShopList();
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ShopCost.vue